import { Component, Input, OnInit } from '@angular/core';
import { NgForm }                   from '@angular/forms';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { SessionModel }             from '../sessions/models/session';
import { CompanyService }           from '../companies/company.service';
import { GsfService }               from './gsf.service';
import { MessagesService }          from '../messages/messages.service';
import { VendorModel }              from '../vendors/models/vendor';
import { VendorSearchService }      from '../vendors/vendor.search.service';

@Component({
  selector   : 'gsf-settings',
  template: require('./gsf.settings.component.html')
})
export class GsfSettingsComponent implements OnInit {
  @Input() session : SessionModel;
  @Input() settings: CompanyIntegrationsModel;


  title  : string = this.gsfService.title;
  vendor : VendorModel;

  constructor (
    public companyService      : CompanyService,
    private gsfService         : GsfService,
    private messagesService    : MessagesService,
    private router             : UIRouter,
    private translateService   : TranslateService,
    private vendorSearchService: VendorSearchService,
  ) {}

  activate () : void {
    this.gsfService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  deactivate () : void {
    this.gsfService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.REMOVED_INTEGRATION', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  getVendor () : void {
    this.vendorSearchService.get(this.settings.gsf_car_parts_vendor_id)
    .then(( vendor : VendorModel ) => {
      this.vendor = vendor;
    });
  }

  handleVendorChange ( vendor : string | VendorModel ) {
    if (!vendor) {
      this.settings.gsf_car_parts_vendor_id = '';
    }
  }

  ngOnInit () : void {
    if ( this.settings.gsf_car_parts_vendor_id ) {
      this.getVendor();
    }
  }

  save ( form : NgForm ) : void {
    this.gsfService.save(this.settings)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  setVendorID ( vendor : VendorModel ) : void {
    this.settings.gsf_car_parts_vendor_id = vendor.id;
  }
}
